import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, CircularProgress, Divider, Modal } from "@mui/material";
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { ReactComponent as FileDownloadIcon } from "../../../../Assets/img/icons/Download-breadcrumb.svg";
import Images from "../../../../Assets/img/ImageUtilities";
import CompleteTexsticon from '../../../../Assets/img/verified.png';
import { getPersonalityTestResult } from "../../../../Redux/Reducers/numerologyReducer";
import ParentComponent from "./ParentComponent";

const PersonalityDetails = () => {

    const dispatch = useDispatch();

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const Numerology = useSelector((state) => state?.numerology?.personalityTestResult);
    console.log("Numerology--------", Numerology);

    useEffect(() => {
        const style = document.createElement('style');
        style.id = 'global-pdf-styles';
        style.innerHTML = `
        @media print {
            .MuiCollapse-root {
                height: auto !important;
                visibility: visible !important;
                display: block !important;
            }
            
            .MuiAccordionDetails-root {
                display: block !important;
                visibility: visible !important;
            }
            
            .MuiAccordionSummary-expandIcon {
                display: none !important;
            }
        }
        
        /* PDF generation helper classes */
        .pdf-accordion-expanded .MuiCollapse-root {
            height: auto !important;
            visibility: visible !important;
            display: block !important;
        }
    `;
        document.head.appendChild(style);

        return () => {
            const existingStyle = document.getElementById('global-pdf-styles');
            if (existingStyle) {
                document.head.removeChild(existingStyle);
            }
        };
    }, []);

    // Add this useEffect to inject PDF-specific styles
    // Add this to your existing useEffect that adds PDF styles
    // useEffect(() => {
    //     const style = document.createElement('style');
    //     style.id = 'pdf-print-styles';
    //     style.innerHTML = `
    //     @media print {
    //         * {
    //             -webkit-print-color-adjust: exact !important;
    //             print-color-adjust: exact !important;
    //         }

    //         body {
    //             background: white;
    //             margin: 0;
    //             padding: 0;
    //         }

    //         .pdf-content {
    //             page-break-inside: avoid;
    //             break-inside: avoid;
    //         }

    //         /* Ensure all text is visible */
    //         p, h1, h2, h3, h4, h5, h6, span, div {
    //             overflow: visible !important;
    //             max-height: none !important;
    //             text-overflow: clip !important;
    //             white-space: normal !important;
    //         }

    //         /* Fix progress bars */
    //         .progress-bar {
    //             background-color: #0fc3ecff !important;
    //             -webkit-print-color-adjust: exact;
    //             print-color-adjust: exact;
    //         }

    //         /* Ensure borders and backgrounds print */
    //         [style*="border"] {
    //             -webkit-print-color-adjust: exact;
    //             print-color-adjust: exact;
    //         }

    //         /* Fix table rendering */
    //         table {
    //             page-break-inside: avoid;
    //             break-inside: avoid;
    //         }

    //         tr {
    //             page-break-inside: avoid;
    //             break-inside: avoid;
    //         }

    //         /* Fix accordion content */
    //         .MuiAccordion-root {
    //             page-break-inside: avoid;
    //             break-inside: avoid;
    //         }

    //         .MuiAccordionDetails-root {
    //             display: block !important;
    //             height: auto !important;
    //             overflow: visible !important;
    //         }

    //         /* Ensure all content is visible */
    //         .MuiCollapse-root {
    //             height: auto !important;
    //             min-height: auto !important;
    //             overflow: visible !important;
    //         }

    //         .MuiCollapse-wrapper {
    //             height: auto !important;
    //             overflow: visible !important;
    //         }

    //         .MuiCollapse-wrapperInner {
    //             height: auto !important;
    //             overflow: visible !important;
    //         }
    //     }
    // `;
    //     document.head.appendChild(style);

    //     return () => {
    //         const existingStyle = document.getElementById('pdf-print-styles');
    //         if (existingStyle) {
    //             document.head.removeChild(existingStyle);
    //         }
    //     };
    // }, []);

    const handleNavigate = () => {
        navigate('/jobopening');
    };

    const handleGetResponse = async () => {
        try {
            const response = await dispatch(getPersonalityTestResult());
            console.log("Response", response);
        } catch (error) {
            console.log("API Response Error------", error);
        }
    };

    useEffect(() => {
        handleGetResponse();
    }, [])

    const pdfRef = useRef(null);

    const [open, setOpen] = useState(false);
    const [planetoryState, setPlanetoryState] = useState('');
    const handleClose = () => {
        setOpen(false);
    };
    const handleOpen = (data) => {
        console.log("DATA-----------", data);
        setPlanetoryState(data);
        setOpen(true);
    };

    const PersonalD = {
        "Time of Birth": Numerology?.tob,
        "Moon Sign": Numerology?.moon_sign,
        "Body Type": Numerology?.body_type
    };

    const PersonalityNumber = {
        "Personality Type": Numerology?.personality_type,
        "Name Number": Numerology?.name_number,
        "Destiny Number": Numerology?.destiny_number
    };

    const BasicGrid = [
        ['4', '9', '2'],
        ['3', '5', '7'],
        ['8', '1', '6']
    ];

    const planitoryAssociationNumbers = ['1', '2', '3', '4', '5', '6', '7', '8', '9'];
    const planitoryAssociationName = [{
        'name': 'Sun',
        'desc': 'Represents leadership,confidence,ego,and authority.', "Energy": "Active,yang", "Element": "Fire", "Affirmation": "I lead with confidence and clarity"
    },
    { 'name': 'Moon', 'desc': 'Associated with emotions intuition,sensitivity and the subconscious.', 'Energy': 'Receptive,Yin', 'Element': 'Water', 'Affirmation': 'I trust intuition and emotions' },
    { 'name': 'Jupiter', 'desc': 'Symbolizes wisdom,growth,optimism,and expansion.', 'Energy': 'Expansive', 'Element': 'Ether', 'Affirmation': 'I attract abundance and growth' },
    { 'name': 'Rahu', 'desc': 'Stands for sudden changes,innovation,illusion and desires', 'Energy': 'Disruptive', 'Element': 'Air', 'Affirmation': 'I embrace changes and transformation' },
    { 'name': 'Mercury', 'desc': 'Represents communication,intellect,reasoning and trade.', 'Energy': 'Adaptive', 'Element': 'Earth', 'Affirmation': 'I communicate with wisdom and clarity' },
    { 'name': 'Venus', 'desc': 'Governs love,beauty,art,luxury and harmony', 'Energy': 'Harmonizing', 'Element': 'Earth', 'Affirmation': 'I Creat harmony in all relationships' },
    { 'name': 'Ketu', 'desc': 'Indicates spirituality,detachment,illusion and mysticism.', 'Energy': 'Introspective', 'Element': 'Water', 'Affirmation': 'I connect with my inner wisdom' },
    { 'name': 'Saturn', 'desc': 'Known for discipline,responsibility,limitation an endurance', 'Enegry': 'Transformative', 'Element': 'Air', 'Affirmation': 'I transform challenges into opportunities' },
    { 'name': 'Mars', 'desc': 'Represents action,energy,aggression and courage', 'Energy': 'Dynamic', 'Element': 'Fire', 'Affirmation': 'I act with courage and passion' }];

    const planitoryAssociationImg = [Images.Sun, Images.Moon, Images.Jupiter, Images.Rahu, Images.Mercury, Images.Venus, Images.Ketu, Images.Saturn, Images.Mars]

    // const handleDownloadPDF = async () => {
    //     const input = pdfRef.current;

    //     // Store original styles
    //     const originalStyles = {
    //         maxHeight: input.style.maxHeight,
    //         overflowY: input.style.overflowY,
    //         position: input.style.position,
    //         left: input.style.left,
    //     };

    //     setLoading(true);
    //     // Temporarily modify styles for full capture
    //     input.style.maxHeight = 'none';
    //     input.style.overflowY = 'visible';
    //     input.style.position = 'absolute';
    //     input.style.left = '-9999px';

    //     try {
    //         // Capture the full content
    //         const canvas = await html2canvas(input, {
    //             scale: 2,
    //             scrollY: 0,
    //             windowHeight: input.scrollHeight,
    //             useCORS: true,
    //             logging: false,
    //         });

    //         // Calculate PDF dimensions
    //         const pdf = new jsPDF('p', 'mm', 'a4');
    //         const pageWidth = pdf.internal.pageSize.getWidth() - 20; // 10mm margins each side
    //         const pageHeight = pdf.internal.pageSize.getHeight() - 20;

    //         // Calculate image dimensions
    //         const imgWidth = pageWidth;
    //         const imgHeight = (canvas.height * imgWidth) / canvas.width;

    //         // Add first page
    //         pdf.addImage(canvas, 'PNG', 10, 10, imgWidth, imgHeight, undefined, 'FAST');

    //         // Add additional pages if needed
    //         let heightLeft = imgHeight - pageHeight;
    //         let position = 10; // Start position for additional pages

    //         while (heightLeft >= 0) {
    //             pdf.addPage();
    //             pdf.addImage(
    //                 canvas,
    //                 'PNG',
    //                 10,
    //                 position - pageHeight, // Adjust position for new page
    //                 imgWidth,
    //                 imgHeight,
    //                 undefined,
    //                 'FAST'
    //             );
    //             heightLeft -= pageHeight;
    //             position += pageHeight;
    //         }

    //         pdf.save('Complete_Personality_Report.pdf');


    //     } catch (error) {
    //         console.error('Error generating PDF:', error);
    //     } finally {
    //         // Restore original styles
    //         input.style.maxHeight = originalStyles.maxHeight;
    //         input.style.overflowY = originalStyles.overflowY;
    //         input.style.position = originalStyles.position;
    //         input.style.left = originalStyles.left;
    //         setLoading(false);
    //     }
    // };

    // const handleDownloadPDF = async () => {
    //     const input = pdfRef.current;

    //     // Store original styles
    //     const originalStyles = {
    //         maxHeight: input.style.maxHeight,
    //         overflowY: input.style.overflowY,
    //         position: input.style.position,
    //         left: input.style.left,
    //         width: input.style.width,
    //     };

    //     setLoading(true);

    //     // Temporarily modify styles for full capture
    //     input.style.maxHeight = 'none';
    //     input.style.overflowY = 'visible';
    //     input.style.position = 'absolute';
    //     input.style.left = '-9999px';
    //     input.style.width = '1024px'; // Fixed width for consistent rendering

    //     try {
    //         // Capture the full content
    //         const canvas = await html2canvas(input, {
    //             scale: 2,
    //             scrollY: 0,
    //             windowHeight: input.scrollHeight,
    //             useCORS: true,
    //             logging: false,
    //             backgroundColor: '#ffffff',
    //             allowTaint: false,
    //         });

    //         // Calculate PDF dimensions
    //         const pdf = new jsPDF({
    //             orientation: 'p',
    //             unit: 'mm',
    //             format: 'a4',
    //             compress: true
    //         });

    //         const pageWidth = pdf.internal.pageSize.getWidth();
    //         const pageHeight = pdf.internal.pageSize.getHeight();

    //         // Margins (in mm)
    //         const margin = 15;
    //         const contentWidth = pageWidth - (margin * 2);

    //         // Calculate image dimensions to fit page width
    //         const imgWidth = contentWidth;
    //         const imgHeight = (canvas.height * imgWidth) / canvas.width;

    //         // Calculate how many pages we need
    //         const pageContentHeight = pageHeight - (margin * 2);
    //         const totalPages = Math.ceil(imgHeight / pageContentHeight);

    //         console.log(`Generating PDF with ${totalPages} pages`);

    //         // Add pages
    //         for (let page = 0; page < totalPages; page++) {
    //             if (page > 0) {
    //                 pdf.addPage();
    //             }

    //             // Calculate the y-position of the current page
    //             const yPosition = - (page * pageContentHeight) + margin;

    //             // Add the image portion for this page
    //             pdf.addImage(
    //                 canvas,
    //                 'PNG',
    //                 margin,
    //                 yPosition,
    //                 imgWidth,
    //                 imgHeight,
    //                 undefined,
    //                 'FAST'
    //             );
    //         }

    //         pdf.save('Complete_Personality_Report.pdf');

    //     } catch (error) {
    //         console.error('Error generating PDF:', error);
    //         alert('Failed to generate PDF. Please try again.');
    //     } finally {
    //         // Restore original styles
    //         input.style.maxHeight = originalStyles.maxHeight;
    //         input.style.overflowY = originalStyles.overflowY;
    //         input.style.position = originalStyles.position;
    //         input.style.left = originalStyles.left;
    //         input.style.width = originalStyles.width;
    //         setLoading(false);
    //     }
    // };

    const handleDownloadPDF = async () => {
        setLoading(true);

        try {
            const originalElement = pdfRef.current;

            // Store original styles
            const originalStyles = {
                overflowY: originalElement.style.overflowY,
                maxHeight: originalElement.style.maxHeight,
                position: originalElement.style.position,
                width: originalElement.style.width
            };

            // Create a container for PDF capture
            const pdfContainer = document.createElement('div');
            pdfContainer.style.width = '1200px';
            pdfContainer.style.backgroundColor = '#ffffff';
            pdfContainer.style.padding = '30px';
            pdfContainer.style.position = 'absolute';
            pdfContainer.style.left = '-9999px';
            pdfContainer.style.top = '0';
            pdfContainer.style.zIndex = '10000';

            // Deep clone the content
            const contentClone = originalElement.cloneNode(true);

            // Process the clone for PDF (expand all accordions, fix layouts)
            await prepareContentForPDF(contentClone);

            pdfContainer.appendChild(contentClone);
            document.body.appendChild(pdfContainer);

            // Wait for rendering and any lazy-loaded content
            await new Promise(resolve => setTimeout(resolve, 1500));

            // Capture with html2canvas
            const canvas = await html2canvas(pdfContainer, {
                scale: 2,
                backgroundColor: '#ffffff',
                logging: true,
                allowTaint: true,
                useCORS: true,
                windowWidth: 1200,
                onclone: (clonedDoc) => {
                    // Apply additional styles in cloned document
                    const style = clonedDoc.createElement('style');
                    style.innerHTML = `
                    * {
                        overflow: visible !important;
                        max-height: none !important;
                        -webkit-print-color-adjust: exact !important;
                        print-color-adjust: exact !important;
                    }
                    
                    /* Force all accordions to be expanded */
                    .MuiCollapse-root {
                        height: auto !important;
                        visibility: visible !important;
                        display: block !important;
                        transition: none !important;
                    }
                    
                    .MuiAccordionDetails-root {
                        display: block !important;
                        visibility: visible !important;
                        max-height: none !important;
                        opacity: 1 !important;
                    }
                    
                    .MuiAccordion-root {
                        page-break-inside: avoid !important;
                        break-inside: avoid !important;
                    }
                    
                    .MuiAccordionSummary-root {
                        cursor: default !important;
                        pointer-events: none !important;
                    }
                    
                    /* Fix table layouts */
                    table {
                        page-break-inside: avoid !important;
                        break-inside: avoid !important;
                        width: 100% !important;
                    }
                    
                    td, th {
                        page-break-inside: avoid !important;
                        break-inside: avoid !important;
                    }
                    
                    /* Fix progress bars */
                    .progress-bar {
                        background-color: #0fc3ecff !important;
                        -webkit-print-color-adjust: exact !important;
                        print-color-adjust: exact !important;
                    }
                    
                    /* Ensure all content is visible */
                    .loshu-grid-section,
                    .planetary-associations-section,
                    .loshu-gaps-section {
                        page-break-inside: avoid !important;
                        break-inside: avoid !important;
                    }
                    
                    /* Fix modal popups (they shouldn't appear in PDF) */
                    .MuiModal-root {
                        display: none !important;
                    }
                `;
                    clonedDoc.head.appendChild(style);
                }
            });

            // Clean up
            document.body.removeChild(pdfContainer);

            // Restore original styles
            originalElement.style.overflowY = originalStyles.overflowY;
            originalElement.style.maxHeight = originalStyles.maxHeight;
            originalElement.style.position = originalStyles.position;
            originalElement.style.width = originalStyles.width;

            // Generate PDF with proper pagination
            await generatePDFWithPages(canvas);

        } catch (error) {
            console.error('Error generating PDF:', error);
            alert('Failed to generate PDF. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    // Helper function to prepare content for PDF
    const prepareContentForPDF = async (clone) => {
        // Remove interactive elements
        const removeSelectors = [
            '[onclick]',
            'button:not(.MuiAccordionSummary-root)',
            '.MuiButton-root',
            '[role="button"]',
            '.hover-cursor-pointer'
        ];

        removeSelectors.forEach(selector => {
            const elements = clone.querySelectorAll(selector);
            elements.forEach(el => {
                el.removeAttribute('onclick');
                el.style.cursor = 'default';
                el.style.pointerEvents = 'none';
            });
        });

        // Handle all accordions - expand them completely
        const accordions = clone.querySelectorAll('.MuiAccordion-root');
        accordions.forEach(accordion => {
            // Remove any collapsed classes
            accordion.classList.remove('Mui-collapsed');
            accordion.classList.add('Mui-expanded');

            // Force expand the collapse container
            const collapseRoot = accordion.querySelector('.MuiCollapse-root');
            if (collapseRoot) {
                collapseRoot.classList.remove('MuiCollapse-hidden');
                collapseRoot.style.height = 'auto';
                collapseRoot.style.visibility = 'visible';
                collapseRoot.style.display = 'block';
                collapseRoot.style.overflow = 'visible';
                collapseRoot.style.transition = 'none';

                // Remove any collapsed classes
                collapseRoot.classList.remove('MuiCollapse-entered');
            }

            // Ensure accordion details are visible
            const accordionDetails = accordion.querySelector('.MuiAccordionDetails-root');
            if (accordionDetails) {
                accordionDetails.style.display = 'block';
                accordionDetails.style.visibility = 'visible';
                accordionDetails.style.overflow = 'visible';
                accordionDetails.style.maxHeight = 'none';
                accordionDetails.style.opacity = '1';
                accordionDetails.style.transform = 'none';
            }

            // Make summary non-clickable but visible
            const summary = accordion.querySelector('.MuiAccordionSummary-root');
            if (summary) {
                summary.style.cursor = 'default';
                summary.style.pointerEvents = 'none';

                // Hide the expand icon
                const expandIcon = summary.querySelector('.MuiAccordionSummary-expandIcon');
                if (expandIcon) {
                    expandIcon.style.display = 'none';
                }
            }
        });

        // Fix all MuiCollapse elements (not just those inside accordions)
        const collapses = clone.querySelectorAll('.MuiCollapse-root');
        collapses.forEach(collapse => {
            collapse.style.height = 'auto';
            collapse.style.visibility = 'visible';
            collapse.style.display = 'block';
            collapse.style.overflow = 'visible';
            collapse.style.transition = 'none';
        });

        // Fix progress bars
        const progressBars = clone.querySelectorAll('.progress-bar');
        progressBars.forEach(bar => {
            bar.style.backgroundColor = '#0fc3ecff';
            bar.style.display = 'flex';
            bar.style.overflow = 'visible';
            bar.style.WebkitPrintColorAdjust = 'exact';
            bar.style.printColorAdjust = 'exact';

            // Ensure width is preserved
            const width = bar.style.width;
            if (width) {
                bar.style.width = width;
            }
        });

        // Fix tables
        const tables = clone.querySelectorAll('table');
        tables.forEach(table => {
            table.style.pageBreakInside = 'avoid';
            table.style.breakInside = 'avoid';
            table.style.width = '100%';
            table.style.borderCollapse = 'collapse';
        });

        // Ensure all elements are visible
        const allElements = clone.querySelectorAll('*');
        allElements.forEach(el => {
            if (el.style) {
                el.style.overflow = 'visible';
                el.style.maxHeight = 'none';

                // Don't override critical display properties
                const computedStyle = window.getComputedStyle(el);
                if (computedStyle.display === 'none' && !el.classList.contains('MuiModal-root')) {
                    // Only unhide non-modal elements
                    el.style.display = 'block';
                }
            }
        });

        // Hide any modal elements
        const modals = clone.querySelectorAll('.MuiModal-root, [role="presentation"]');
        modals.forEach(modal => {
            modal.style.display = 'none';
        });
    };

    // Helper function to generate PDF with proper pages
    const generatePDFWithPages = async (canvas) => {
        // Create PDF with A4 size
        const pdf = new jsPDF({
            orientation: 'portrait',
            unit: 'px',
            format: 'a4',
            compress: true
        });

        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();

        // Margins (in pixels)
        const margin = 40;
        const contentWidth = pageWidth - (margin * 2);

        // Calculate image dimensions
        const imgWidth = contentWidth;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        // Convert canvas to image
        const imgData = canvas.toDataURL('image/png', 1.0);

        // Calculate number of pages needed
        const pageContentHeight = pageHeight - (margin * 2);
        const totalPages = Math.ceil(imgHeight / pageContentHeight);

        // Add pages
        for (let i = 0; i < totalPages; i++) {
            if (i > 0) {
                pdf.addPage();
            }

            // Calculate y-position for this page
            const yPosition = margin - (i * pageContentHeight);

            pdf.addImage(
                imgData,
                'PNG',
                margin,
                yPosition,
                imgWidth,
                imgHeight,
                undefined,
                'FAST'
            );
        }

        pdf.save('Complete_Personality_Report.pdf');
    };



    return (
        <>

            <ParentComponent className="m-3 px-3 d-flex justify-content-center rounded pt-1">

                {Numerology === null ? (
                    <div className="d-flex flex-column align-items-center justify-content-center p-2">
                        <img
                            src={CompleteTexsticon}
                            alt="Personality Test"
                            className="mb-4"
                            style={{ width: '150px', maxWidth: '25%', opacity: 0.8 }}
                        />

                        <h2 className="fw-bold text-center mb-3">Complete your Personality Test</h2>

                        <p className="text-muted text-center fs-5 mb-4">
                            There is not enough data to show your results yet.
                        </p>

                        <Link
                            to="/personalitytest"
                            className="text-primary text-decoration-none fw-medium"
                            style={{ fontSize: '1.1rem' }}
                        >
                            Take Personality Test →
                        </Link>
                    </div>
                ) : loading ? (
                    <div className="d-flex flex-column align-items-center justify-content-center p-5">
                        <CircularProgress color="primary" />
                        <h5 className="fw-bold mt-3">Generating PDF...</h5>
                        <p className="text-muted">Please wait while we prepare your report.</p>
                    </div>
                ) : (
                    <div
                        className="shadow px-5 rounded"
                        style={{
                            maxHeight: '680px', // or any desired height
                            overflowY: 'auto',
                            scrollbarWidth: "thin",
                            width: "80%",
                            border: "1px solid rgba(0,82,204,0.2)",
                            backgroundColor: '#ffffff'
                        }}
                        ref={pdfRef}
                    >
                        <div className="pdf-content" style={{ backgroundColor: '#ffffff' }}>
                            <div className="d-flex flex-row justify-content-between pt-4">
                                <h2 className="fw-bold" style={{
                                    color: "rgba(7, 7, 142, 1)",
                                    fontSize: "32px" // important for proper rendering
                                }}>Personality Result</h2>
                                <div className="pt-2 d-flex flex-row align-items-center" onClick={() => handleDownloadPDF()}>
                                    <FileDownloadIcon width="20" height="20" />
                                    <h6 className="ps-1 fw-bold">Save</h6>
                                </div>
                            </div>
                            <div className="d-flex flex-column justify-content-start align-items-start gap-1 rounded shadow p-2 pb-4 mt-2">
                                <div className="d-flex flex-row justify-content-between w-100 px-1">
                                    <h5 className="fw-semibold">Personal Details</h5>

                                </div>

                                <div className="d-flex flex-row justify-content-evenly gap-2 pr-2 w-100">
                                    {/* {Object.entries(PersonalD)?.map(([label, value]) => ( */}
                                    <div className="d-flex flex-column justify-content-between rounded w-25 p-2" style={{ border: "1px solid rgba(0,82,204,0.2)" }}>
                                        <div className="fw-semibold" style={{ color: "#0dcaf0" }}>Time of Birth</div>
                                        <div>{Numerology?.tob}</div>
                                    </div>
                                    <div className="d-flex flex-column justify-content-between rounded w-25 p-2" style={{ border: "1px solid rgba(0,82,204,0.2)" }}>
                                        <div className="fw-semibold" style={{ color: "#FFC107" }}>Moon Sign</div>
                                        <div>{Numerology?.moon_sign}</div>
                                    </div>
                                    <div className="d-flex flex-column justify-content-between rounded w-25 p-2" style={{ border: "1px solid rgba(0,82,204,0.2)" }}>
                                        <div className="fw-semibold" style={{ color: "#0d6efd" }}>Body Type</div>
                                        <div>{Numerology?.body_type}</div>
                                    </div>
                                    <div className="d-flex flex-column justify-content-between rounded w-25 p-2" style={{ border: "1px solid rgba(0,82,204,0.2)" }}>
                                        <div className="fw-semibold" style={{ color: "#5d25cdff" }}>Personality Type</div>
                                        <div>{Numerology?.personality_type}</div>
                                    </div>
                                </div>

                            </div>

                            <div className="d-flex flex-column loshu-grid-section">
                                <h5 className="fw-bold pt-4" style={{ color: "#0dcaf0" }}>Loshu Grid Comparison</h5>
                                <div className="d-flex flex-row gap-4">
                                    <div className="rounded p-2 w-50" style={{ border: "1px solid rgba(0,82,204,0.2)", background: "#F5FBFF" }}>
                                        <h6 className="fw-semibold text-center" style={{ color: "#0044c6" }}>Your Grid</h6>
                                        <table className="table table-bordered text-center rounded" style={{ border: "1px solid rgba(0,82,204,0.2)", backgroundColor: "#F5FBFF" }}>
                                            <tbody>
                                                {Numerology?.your_loshu_grid?.map((value, rowindex) => (
                                                    <tr key={rowindex}>
                                                        {value?.map((cell, index) => (
                                                            <td key={index} className="p-3 fw-bold">{cell}</td>
                                                        ))}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className="rounded p-2 w-50" style={{ border: "1px solid rgba(0,82,204,0.2)", background: "#F5FBFF" }}>
                                        <h6 className="fw-semibold text-center" style={{ color: "#0044c6" }}>Basic Grid</h6>
                                        <table className="table table-bordered text-center rounded" style={{ border: "1px solid rgba(0,82,204,0.2)", backgroundColor: "#F5FBFF" }}>
                                            <tbody>
                                                {BasicGrid?.map((value, rowindex) => (
                                                    <tr key={rowindex}>
                                                        {value?.map((value, index) => (
                                                            <td key={index} className="p-3 fw-bold">{value}</td>
                                                        ))}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="py-4 "> */}
                            <div className="py-4 planetary-associations-section" style={{ pageBreakBefore: 'always' }}>
                                <h5 className="fw-semibold pb-1" style={{ color: "#0dcaf0" }}>Planetary Associations</h5>
                                <div className="d-flex flex-wrap gap-4 align-items-center rounded justify-content-center mb-2 p-2 py-4" style={{ border: "1px solid rgba(0,82,204,0.2)" }}>
                                    {planitoryAssociationNumbers?.map((num, index) => (
                                        <div
                                            key={index}
                                            className="rounded d-flex flex-row justify-content-between align-items-center p-2"
                                            style={{ width: "200px", border: "1px solid rgba(0,82,204,0.2)", background: "#F5FBFF" }}
                                            onClick={() => handleOpen(num)}
                                        >
                                            <div className="d-flex flex-column align-items-start justify-content-between">
                                                <h6 className="fw-semibold mb-1">{num}</h6>
                                                <h6 className="fw-semibold">{planitoryAssociationName[index]?.name}</h6>
                                            </div>
                                            <div className="d-flex align-items-center justify-content-center">
                                                <img
                                                    src={planitoryAssociationImg[index]}
                                                    alt={planitoryAssociationName[index]?.name}
                                                    style={{ width: "25%", height: "25%" }}
                                                />
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <div className="w-100 shadow rounded p-2 px-4 mb-2">
                                <div className="d-flex align-items-center justify-content-center">
                                    <h4 className="fw-bold pb-2 text-center" style={{
                                        color: "rgba(7, 7, 142, 1)",
                                        display: "inline-block" // important for proper rendering
                                    }}>Numerology & Financial State</h4>
                                </div>

                                <div>
                                    <div className="py-2 px-2 my-1"
                                        style={{
                                            borderLeft: "5px solid #0044c6",
                                            borderTop: "1px solid #F5FBFF",
                                            borderRight: "1px solid #F5FBFF",
                                            borderBottom: "1px solid #F5FBFF",
                                            background: "#F5FBFF",
                                            borderTopLeftRadius: "10px",
                                            borderBottomLeftRadius: "10px"
                                        }}>
                                        <h6 className="pl-2 fw-semibold">Name Number:{Numerology?.name_number}</h6>
                                    </div>

                                    <div className="py-2 px-2 my-3"
                                        style={{
                                            borderLeft: "5px solid #8A2BE2",
                                            borderTop: "1px solid #F5FBFF",
                                            borderRight: "1px solid #F5FBFF",
                                            borderBottom: "1px solid #F5FBFF",
                                            background: "#F5FBFF",
                                            borderTopLeftRadius: "10px",
                                            borderBottomLeftRadius: "10px"
                                        }}>
                                        <h6 className="fw-semibold">Destiny Number:{Numerology?.destiny_number}</h6>
                                    </div>

                                    <div className="py-2 my-3 px-2"
                                        style={{
                                            borderLeft: "5px solid #0fc3ecff",
                                            borderTop: "1px solid #F5FBFF",
                                            borderRight: "1px solid #F5FBFF",
                                            borderBottom: "1px solid #F5FBFF",
                                            background: "#F5FBFF",
                                            borderTopLeftRadius: "10px",
                                            borderBottomLeftRadius: "10px"
                                        }}>

                                        <h6 className="fw-semibold">Financial Potential</h6>
                                        <div>
                                            {Object.entries(Numerology?.financial_potential || {})?.map(([key, value]) => (
                                                <div key={key} className="mb-1">
                                                    <span className="fw-bold text-capitalize" style={{ fontSize: "16px" }}>{key.replaceAll('_', ' ')}:</span>
                                                    <p>{value}</p>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* <div> */}
                            {/* <div className="shadow rounded my-4 px-3 py-2"> */}
                            <div className="shadow rounded my-4 px-3 py-2 loshu-gaps-section">
                                <h5 className="fw-bold my-1" style={{ color: "#0fc3ecff" }}>
                                    Specific Insights
                                </h5>
                                <div className="mt-3">
                                    <Accordion className="rounded" style={{ border: "1px solid rgba(0,82,204,0.2)" }}>
                                        <AccordionSummary className="rounded"
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1-content"
                                            id="panel1-header"
                                            style={{ border: "1px solid rgba(0,82,204,0.2)", borderWidth: "1px" }}
                                        >
                                            <Typography component="span" style={{ color: "#0052CC" }} className="fw-semibold"> Name Number Insight</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails className="rounded" style={{ background: "#F5FBFF", }} >
                                            <Typography>
                                                {Numerology?.specific_insights?.name_number_insight}
                                            </Typography>
                                        </AccordionDetails>
                                    </Accordion>

                                </div>

                                <div className="mt-3">

                                    <Accordion className="rounded" style={{ border: "1px solid rgba(0,82,204,0.2)" }}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1-content"
                                            id="panel1-header"
                                            style={{ border: "1px solid rgba(0,82,204,0.2)", borderWidth: "1px" }}
                                            className="rounded"
                                        >
                                            <Typography component="span" style={{ color: "#0052CC" }} className="fw-semibold">Loshu Strenghts</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails style={{ background: "#F5FBFF", }}>
                                            <div>
                                                {Numerology?.specific_insights?.loshu_strengths?.map((value, index) => (
                                                    <div key={index} className="d-flex flex-row">

                                                        <Typography className="fw-bold pe-1">{value?.number}</Typography>
                                                        <Typography>{value?.qualities}</Typography>
                                                    </div>
                                                ))}
                                            </div>
                                        </AccordionDetails>
                                    </Accordion>

                                </div>

                                <div className="mt-3">
                                    <Accordion className="rounded" style={{ border: "1px solid rgba(0,82,204,0.2)" }}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1-content"
                                            id="panel1-header"
                                            className="rounded"
                                            style={{ border: "1px solid rgba(0,82,204,0.2)", borderWidth: "1px" }}
                                        >
                                            <Typography component="span" style={{ color: "#0052CC" }} className="fw-semibold">Loshu Gaps</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails style={{ background: "#F5FBFF", }}>
                                            <Typography className="fw-bold pe-1">You should focus on the areas listed below:</Typography>
                                            {Numerology?.specific_insights?.loshu_gaps?.map((value, index) => (
                                                <div key={index} className="d-flex flex-row">

                                                    <Typography className="fw-bold pe-1">{value?.number}</Typography>
                                                    <Typography>{value?.qualities}</Typography>
                                                </div>
                                            ))}
                                        </AccordionDetails>
                                    </Accordion>

                                </div>

                                <div className="mt-3 mb-3">
                                    <Accordion className="rounded" style={{ border: "1px solid rgba(0,82,204,0.2)" }}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1-content"
                                            id="panel1-header"
                                            className="rounded"
                                            style={{ border: "1px solid rgba(0,82,204,0.2)", borderWidth: "1px" }}
                                        >
                                            <Typography component="span" style={{ color: "#0052CC" }} className="fw-semibold">Mind body alignment</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails style={{ background: "#F5FBFF", }}>
                                            <div className="d-flex flex-row">
                                                <h6 className="fw-semibold mr-1">Do:</h6>
                                                <Typography>{Numerology?.specific_insights?.mind_body_alignment?.positives}.</Typography>

                                            </div>
                                            <div className="d-flex flex-row">
                                                <h6 className="fw-semibold mr-1">Don't:</h6>

                                                <Typography>{Numerology?.specific_insights?.mind_body_alignment?.negatives}</Typography>
                                            </div>
                                        </AccordionDetails>
                                    </Accordion>

                                </div>

                            </div>
                            <div className="rounded shadow px-3 py-2 my-4">
                                <h5 className="fw-bold py-2" style={{ color: "#0dcaf0" }}>
                                    Recommended Job Roles:
                                </h5>
                                <div className="d-flex flex-column my-2  border rounded">
                                    {Numerology?.recommended_jobs?.map((value, index) => (
                                        <div className="d-flex flex-column" style={{ background: "#F5FBFF", }}>
                                            <div
                                                key={index}
                                                className="d-flex flex-column px-3 py-1 hover-cursor-pointer"
                                            >
                                                <h6 className="fw-semibold m-0">{value?.title}</h6>


                                                <div className="d-flex flex-row justify-content-between align-items-center py-1">
                                                    <div className="d-flex align-items-start">
                                                        <div className="progress" style={{ width: '500px', height: '10px' }}>
                                                            <div
                                                                className="progress-bar"
                                                                role="progressbar"
                                                                style={{ width: `${value?.probability}%`, backgroundColor: "#0fc3ecff" }}
                                                                aria-valuenow={value?.probability}
                                                                aria-valuemin="0"
                                                                aria-valuemax="100"
                                                            ></div>
                                                        </div>
                                                    </div>
                                                    <span
                                                        className="fw-semibold rounded-pill px-1"
                                                        style={{ color: '#000000', }}
                                                    >
                                                        {value?.probability}%
                                                    </span>
                                                </div>
                                            </div>

                                            <Divider sx={{ height: "1px" }} className="bg-dark" />
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <div className="d-flex flex align-items-center justify-content-center" onClick={handleNavigate}>
                                <p className="py-2 px-4 fw-semibold" style={{ display: "inline-block", borderRadius: "30px", background: "#0fc3ecff", color: '#ffffff' }}>Explore Jobs</p>
                            </div>

                        </div>

                    </div>
                )}


                <Modal
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box
                        sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: "auto",
                            bgcolor: "#F5FBFF",
                            boxShadow: "0px 4px 4px 0px #00000040",
                            // p: 1,
                            borderRadius: 2,
                            minWidth: "45%",
                            maxHeight: "80%",
                            overflowY: "auto",
                        }}
                    >
                        <div className="">
                            <div className="d-flex flex-row justify-content-between mt-3 px-2 mb-1">
                                <div className="d-flex flex-row align-items-center justify-content-center">
                                    <Typography id="modal-modal-title" variant="h6" component="h2" className="px-2">
                                        {planetoryState}
                                    </Typography>
                                    <img
                                        src={planitoryAssociationImg[planetoryState - 1]}
                                        alt={planitoryAssociationName[planetoryState - 1]}
                                        style={{ width: "20px", height: "20px" }}
                                    />
                                </div>
                                <div>
                                    <Typography id="modal-modal-title px-3" variant="h6" component="h2">
                                        {planitoryAssociationName[planetoryState - 1]?.name}
                                    </Typography>
                                </div>
                            </div>
                            <Divider sx={{ height: "1px" }} className="bg-dark" />
                            <Typography id="modal-modal-description" sx={{ mt: 2 }} className="my-2 mx-3 fw-semibold">
                                {planitoryAssociationName[planetoryState - 1]?.desc}
                            </Typography>
                            <Divider sx={{ height: "1px" }} className="bg-dark mx-3" />
                            <div className="d-flex flex-column py-3 px-2 mx-3">
                                <h6 className="fw-semibold" style={{ color: "#0dcaf0" }}>Planetary Influence</h6>
                                <div className="d-flex flex-row align-items-center justify-content-between">
                                    <div className="d-flex flex-column">
                                        <h6>Energy</h6>
                                        <h6 className="fw-semibold">{planitoryAssociationName[planetoryState - 1]?.Energy}</h6>
                                    </div>
                                    <div className="d-flex flex-column">
                                        <h6>Element</h6>
                                        <h6 className="fw-semibold">{planitoryAssociationName[planetoryState - 1]?.Element}</h6>
                                    </div>
                                </div>
                            </div>

                            <div className="d-flex flex-column rounded border py-3 ps-2 mb-3 mx-3">
                                <h6>
                                    Affirmation
                                </h6>
                                <h6 className="fw-semibold" style={{ color: "#0044c6" }}>
                                    {planitoryAssociationName[planetoryState - 1]?.Affirmation}
                                </h6>
                            </div>
                        </div>

                    </Box>
                </Modal>

            </ParentComponent >

        </>



    );
};

export default PersonalityDetails;